import React, { useEffect, useRef } from 'react';
import bemCn from 'bem-cn';
import { Modal, ModalBody } from 'reactstrap';
import useMobileScreen from '../../services/hooks/useMobileScreen';
import SvgCross2 from 'src/assets/svg/SvgCross2.svg';
import './index.scss';

const b = bemCn('modal-mobile');

const timeout = { timeout: 80 };

const ModalMobile = ({
    isBlur = false,
    isCentered = false,
    isOpen = false,
    toggle,
    title = '',
    children,
    className = '',
    resetFilter,
    resetFilterText = 'Reset all',
    contentClassName = '',
    onReset = () => {},
}) => {
    const startY = useRef(null);
    const modalRef = useRef(null);
    const contentRef = useRef(null);
    const startedAtTop = useRef(false);
    const isFirstRender = useRef(true);
    const isMobile = useMobileScreen();

    const handleTouchStart = (e) => {
        if (!isMobile) {
            return;
        }

        startY.current = e.touches[0].clientY;
        startedAtTop.current = contentRef.current && contentRef.current.scrollTop <= 0;
    };

    const handleTouchEnd = (e) => {
        if (!isMobile || startY.current === null) {
            return;
        }

        const endY = e.changedTouches[0].clientY;
        const diff = endY - startY.current;

        if (startedAtTop.current && diff > 80 && contentRef.current?.scrollTop <= 0) {
            toggle();
        }

        startY.current = null;
    };

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        let timer;

        if (!isOpen) {
            timer = setTimeout(() => {
                document.body.style.removeProperty('overflow');
            }, 120);
        }

        return () => clearTimeout(timer);
    }, [isOpen]);

    return (
        <Modal
            centered={isCentered}
            isOpen={isOpen}
            toggle={toggle}
            className={`${b()} ${className}`}
            backdropTransition={timeout}
            modalTransition={timeout}
            modalClassName={`modal-mobile-wrapper ${isBlur ? 'modal-mobile-blur' : ''}`}
            contentClassName={contentClassName}
        >
            <ModalBody>
                <div ref={modalRef} className={b('container')} onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
                    {title && (
                        <div className={b('title')}>
                            <p className="snif-s1 snif-regular mb-0">
                                <span className="text">{title}</span>
                                <SvgCross2 className={b('close-button', { resetFilter })} onClick={toggle} />
                                <span className={b('rectangle-mobile')} />
                                {resetFilter && (
                                    <span className="snif-s2 snif-medium reset-all" onClick={onReset}>
                                        {resetFilterText}
                                    </span>
                                )}
                            </p>
                        </div>
                    )}
                    <div className={b('content')} ref={contentRef}>
                        {children}
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default React.memo(ModalMobile);
